export const SATISFIED_CUSTOMERS_TESTIMONIALS = [
  { commentKey: 'I am absolutely thrilled! There was basically nothing wrong...', firstName: 'Darja', lastName: 'Rosocha' },
  { commentKey: 'The process was straightforward and quick...', firstName: 'Giovanna', lastName: 'Dehmel' },
  { commentKey: 'When I came across Repair Rebels, I was less skeptical...', firstName: 'Claudia', lastName: 'G' },
  { commentKey: 'Thank you very much for this smooth and seamless process...', firstName: 'Anne', lastName: 'B' },
  { commentKey: 'From the initial complaint to receiving the repaired shoes...', firstName: 'Yvonne', lastName: 'Brizuela' },
];
